import React, { Component } from "react";
import axios from "axios";
import { routes } from "../General";
import Alerts from "../../util/Alerts";
import moment from "moment";
import { siniestroIsLiquidado } from "../../coms/BlkGenerales";

export class Contratante extends Component {
    constructor(props) {
        super(...arguments);
        this.state = { deducibles: {} };
    }

    componentDidMount() {
        this.getValDeducible();
    }

    imprimir = () => {
        axios
            .get(routes.api + "/siniestro/imprimir", {
                params: {
                    cdIncSiniestro: this.props.siniestro.cdIncSiniestro,
                    cdReclamo: this.props.siniestro.cdReclamo,
                    cdCompania: this.props.siniestro.cdCompania,
                },
                responseType: "arraybuffer",
            })
            .then(response => {
                let blob = new Blob([response.data], { type: "application/pdf" });
                let url = window.URL.createObjectURL(blob);
                window.open(url);
                this.props.alert.show_info("Generado con éxito");
            })
            .catch(error => {
                this.props.alert.handle_error("Error al generar PDF. Consulte con el administrador del sistema.");
            });
    };
    getValDeducible = () => {
        axios
            .get(routes.apiGen + "/siniestro/valdeducible", {
                params: {
                    cdCompania: this.props.siniestro.cdCompania,
                    cdIncSiniestro: this.props.siniestro.cdIncSiniestro,
                },
            })
            .then(resp => {
                this.setState({ deducibles: resp.data });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    fechaFormato = (fecha, format = "DD/MMM/YYYY") => {
        return fecha ? moment(fecha).locale("moment/locale/es").format(format) : "";
    };

    render() {
        let { siniestro, cliente, diasExtra } = this.props;
        let dias2 = siniestro.dias2 ? siniestro.dias2 : 0;
        let dias = siniestro.dias ? siniestro.dias : 0;
        let dias3 = (diasExtra || {}).dias;
        let fechaEstimada = (diasExtra || {}).dueDate;

        let liquidacion = this.props.liquidacion;
        let obs = "";
        if (liquidacion && liquidacion.length > 0) {
            obs = liquidacion[0].obsPago;
        }

        return (
            <div className="col-lg-3 bg-primary pd-lateral pt-2 pt-md-">
                <Alerts ref={this.alert} />
                <table className="m-auto text-left fs12 line-height-normal">
                    <tbody>
                        <tr>
                            <td className="font-weight-bolder text-primary">Contratante:</td>
                        </tr>
                        <tr>
                            <td>{cliente.titular}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">No. Siniestro:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.numSiniestro}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Alcance:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.item}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Póliza:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.poliza}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Titular:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.titular}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Paciente:</td>
                        </tr>
                        <tr>
                            <td> {siniestro.dscObjeto}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Incapacidad:</td>
                        </tr>
                        <tr>
                            <td> {siniestro.nmIncapacidad}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Val Incurrido:</td>
                        </tr>
                        <tr>
                            <td>${siniestro.valIncurrido}</td>
                        </tr>
                        {siniestroIsLiquidado(siniestro) && (
                            <>
                                <tr>
                                    <td className="font-weight-bolder text-primary">Valor Liquidado:</td>
                                </tr>
                                <tr>
                                    <td>${this.state.deducibles.liquidacion}</td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bolder text-primary">Deducible Aplicado:</td>
                                </tr>
                                <tr>
                                    <td>${this.state.deducibles.deducible} </td>
                                </tr>
                            </>
                        )}
                        <tr>
                            <td className="font-weight-bolder text-primary">Ramo:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.nmRamo}</td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Aseguradora:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.nmAseg}</td>
                        </tr>
                        <tr>
                            {diasExtra ? (
                                <td className="font-weight-bolder text-primary">No. de días liquidado/transcurridos</td>
                            ) : (
                                <td className="font-weight-bolder text-primary">Dias Transcurridos:&nbsp;</td>
                            )}
                        </tr>
                        <tr>
                            <td>
                                <td> {dias3 ? dias3 : siniestro.estado === "X" ? dias2 : dias} </td>
                            </td>
                        </tr>
                        <tr>
                            <td className="font-weight-bolder text-primary">Tipo Sin:</td>
                        </tr>
                        <tr>
                            <td> {siniestro.tpSiniestro}</td>
                        </tr>
                        {fechaEstimada && (
                            <>
                                <tr>
                                    <td className="font-weight-bolder text-primary">Fecha estimada Liq.:</td>
                                </tr>
                                <tr>
                                    <td className={`${diasExtra.fechaEstimadaOld ? "text-danger" : ""}`}>
                                        {this.fechaFormato(fechaEstimada)}
                                    </td>
                                </tr>
                            </>
                        )}
                        <tr>
                            <td className=" font-weight-bolder text-primary">Observaciones:</td>
                        </tr>
                        <tr>
                            <td>{obs}</td>
                        </tr>
                        <br />
                    </tbody>
                </table>
            </div>
        );
    }
}
